var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 123"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 213",
    cx: 14,
    cy: 13.5078,
    r: 13,
    fill: "#4D4D4D",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 120"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 559",
    x: 8.04263,
    y: 8.0918,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(-45 8.04263 8.0918)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 560",
    x: 19.418,
    y: 7.54947,
    width: 0.766019,
    height: 16.0864,
    rx: 0.38301,
    transform: "rotate(45 19.418 7.54947)",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 0.766019
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/CloseButton.1c7e81e8eea9bc97e33be9bcc1110dcb.svg";
export { ForwardRef as ReactComponent };